import Vue from "vue";
import Router from "vue-router";

import Home from "@/components/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/components/login/Login.vue")
    },
    {
      path: "/",
      component: Home,
      children: [
        {
          path: "",
          redirect: "highlights"
        },
        {
          path: "highlights",
          name: "highlights", 
          component: () => import("@/components/dashboard/highlights/Highlights")
        },
        {
          path: "dashboard",
          name: "dashboard",
          component: () => import("@/components/dashboard/Dashboard")
        },
        {
          path: "admin",
          name: "admin",
          component: () => import("@/components/admin/Admin"),
        },
        {
          path: "inquiries",
          name: "inquiries",
          component: () => import("@/components/inquiries/Inquiries"),
          children: [
            {
              path: "all",
              name: "allinquiries",
              component: () =>
                import("@/components/inquiries/all_inquiries/AllInquiries")
            },
            {
              path: "new",
              name: "newinquiry",
              component: () =>
                import("@/components/inquiries/new_inquiry/NewInquiry")
            },
            {
              path: ":id",
              name: "inquiry",
              component: () => import("@/components/inquiries/inquiry/Inquiry")
            }
          ]
        },
        {
          path: "orders",
          name: "orders",
          component: () => import("@/components/orders/Orders"),
          children: [
            {
              path: "all",
              name: "allorders",
              component: () =>
                import("@/components/orders/all_orders/AllOrders")
            },
            {
              path: ":id",
              name: "order",
              component: () => import("@/components/orders/order/Order")
            }
          ]
        },
        {
          path: "ohra",
          name: "ohraneworder",
          component: () => import("@/components/ohra/NewOrder")
        },
        {
          path: "synatec-orders",
          name: "allsynatecorders",
          component: () => import("@/components/synatec_orders/AllSynatecOrders")
        },
        {
          path: "synatec-orders/:id",
          name: "synatecorder",
          component: () => import("@/components/synatec_orders/synatec_order/SynatecOrder")
        },
        {
          path: "invoices",
          name: "invoices",
          component: () => import("@/components/invoices/Invoices"),
          children: [
            {
              path: "all",
              name: "allinvoices",
              component: () =>
                import("@/components/invoices/all_invoices/AllInvoices")
            },
            {
              path: ":id",
              name: "invoice",
              component: () => import("@/components/invoices/invoice/Invoice")
            }
          ]
        },
        {
          path: "devices",
          name: "devices",
          component: () => import("@/components/devices/Devices"),
          children: [
            {
              path: "all",
              name: "alldevices",
              component: () =>
                import("@/components/devices/all_devices/AllDevices")
            },
            {
              path: ":id",
              name: "device",
              component: () =>
                import("@/components/devices/device/Device")
            },
          ]
        },
        {
          path: "parking",
          name: "parking",
          component: () => import("@/components/parking/Parking")
        },
        {
          path: "customers",
          name: "customers",
          component: () => import("@/components/customers/Customers"),
          children: [
            {
              path: "all",
              name: "allcustomers",
              component: () =>
                import("@/components/customers/all_customers/AllCustomers")
            },
            {
              path: "all-old",
              name: "allcustomers-old",
              component: () =>
                import("@/components/customers/all_customers/AllCustomersOld")
            },
            {
              path: "merge",
              name: "mergecustomers",
              component: () =>
                import("@/components/customers/customers_merge/CustomersMerge")
            },
            {
              path: ":id",
              name: "customer",
              component: () =>
                import("@/components/customers/customer/Customer")
            }
          ]
        },
        {
          path: "items",
          name: "items",
          component: () => import("@/components/items/Items"),
          children: [
            {
              path: "all",
              name: "allitems",
              component: () => import("@/components/items/all_items/AllItems")
            },
            {
              path: "new",
              name: "newitem",
              component: () => import("@/components/items/new_item/NewItem")
            },
            {
              path: ":id",
              name: "item",
              component: () => import("@/components/items/item/Item")
            }
          ]
        },
        {
          path: "installations",
          name: "installations",
          component: () =>
            import("@/components/installations/Installations.vue/"),
          children: [
            {
              path: "all",
              name: "allinstallations",
              component: () =>
                import(
                  "@/components/installations/all_installations/AllInstallations.vue/"
                )
            }
          ]
        },
        
        {
          path: "terminations",
          name: "terminations",
          component: () =>
            import("@/components/terminations/Terminations.vue/"),
          children: [
            {
              path: "all",
              name: "allterminations",
              component: () =>
                import(
                  "@/components/terminations/all_terminations/AllTerminations.vue/"
                )
            }
          ]
        },
        {
          path: "kill_list",
          name: "kill_list",
          component: () =>
            import("@/components/kill_list/KillList.vue"),
          children: [
            {
              path: "all",
              name: "allkilllist",
              component: () =>
                import(
                  "@/components/kill_list/all_kill_list/AllKillList.vue"
                )
            }
          ]
        },
        {
          path: "services",
          name: "services",
          component: () => import("@/components/services/Services.vue/"),
          children: [
            {
              path: "all",
              name: "allservices",
              component: () =>
                import("@/components/services/all_services/AllServices.vue/")
            },
            {
              path: ":id",
              name: "service",
              component: () =>
                import("@/components/services/service/Service.vue/")
            }
          ]
        },
        {
          path: "permissions",
          name: "permissions",
          component: () => import("@/components/permissions/Permissions"),
          children: [
            {
              path: "all",
              name: "allpermissions",
              component: () =>
                import(
                  "@/components/permissions/all_permissions/AllPermissions"
                )
            },
            {
              path: "edit/:id",
              name: "editpermissions",
              component: () =>
                import(
                  "@/components/permissions/edit_permissions/EditPermissions"
                )
            }
          ]
        },
        {
          path: "import",
          name: "import",
          component: () => import("@/components/common/import_tool/ImportTool")
        }
      ]
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
